// removed by extract-text-webpack-plugin
module.exports = {"register-box":"register-box","register-logo":"register-logo","register-box-body":"register-box-body","google-captcha":"google-captcha","has-feedback":"has-feedback","form-group":"form-group","form-control":"form-control","fg-custom":"fg-custom","form-control-feedback":"form-control-feedback","term":"term","terms-of-use":"terms-of-use","btn-submit":"btn-submit","btn-fb":"btn-fb","text-btn":"text-btn","social-auth-links":"social-auth-links","hr-text":"hr-text","register-now":"register-now"};


//////////////////
// WEBPACK FOOTER
// ./components/register/_RegisterForm.scss
// module id = ./components/register/_RegisterForm.scss
// module chunks = 0